import React, { useEffect, useState } from 'react';
import { Tooltip, Box, Typography, makeStyles } from '@material-ui/core';

import { useLocalStorage } from '@clef/client-library';
import { PulsingDot } from '@/components/OnboardingHighlightBadge';

const useStyles = makeStyles(theme => ({
  popper: {
    pointerEvents: 'auto',
    zIndex: 1300,
  },
  arrow: {
    color: theme.palette.blue[700],
  },
  tooltip: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.blue[700],
  },
  gotIt: {
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 700,
  },
  SaveSubsetSnapshotPos: {
    position: 'absolute',
    left: 0,
    top: 8,
    zIndex: 1300,
  },
}));

export interface SaveSubsetSnapshotTipsProps {}

export const SaveSubsetSnapshotTips: React.FC<SaveSubsetSnapshotTipsProps> = () => {
  const styles = useStyles();

  const [shownSaveSubsetSnapshotTips, setSaveSubsetSnapshotTips] = useLocalStorage(
    'shownSaveSubsetSnapshotTips',
  );

  const [showTips, setShowTips] = useState(false);
  // wait for the options menu popper rendered, let the tooltip calculate the right position
  useEffect(() => {
    setTimeout(() => {
      setShowTips(true);
    }, 200);
  }, []);

  return (
    <>
      {shownSaveSubsetSnapshotTips ? (
        <></>
      ) : (
        <Tooltip
          open={showTips}
          arrow
          placement="left"
          classes={{
            popper: styles.popper,
            arrow: styles.arrow,
            tooltip: styles.tooltip,
          }}
          title={
            <Box display="flex" alignItems="flex-end" flexDirection="column">
              <Typography>
                {t(
                  '{{action}} You can use snapshots to train models and create new projects. You can revert back to a snapshot at any time.',
                  {
                    action: <strong>{'Save a subset of your dataset as a snapshot.'}</strong>,
                  },
                )}
              </Typography>
              <Box
                onClick={() => setSaveSubsetSnapshotTips(true)}
                className={styles.gotIt}
                marginTop={3}
              >
                {t('Got it')}
              </Box>
            </Box>
          }
        >
          <Box className={styles.SaveSubsetSnapshotPos}>
            <PulsingDot />
          </Box>
        </Tooltip>
      )}
    </>
  );
};

export default SaveSubsetSnapshotTips;
